import { Table } from 'antd';
import React, { useMemo } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { DAYTIME_FORMAT } from '../../constants';
import useColumnConfig from '../../hooks/useColumnConfig';
import ColumnConfigDrawer from '../ColumnConfigDrawer';

const FIXED_KEYS = ['name', 'action'];

export default function HubsTable({ withAction, dataSource, selectedRowKeys, onSelectChange, configRef, ...props }) {
  const { t } = useTranslation('hubs');
  const { t: tc } = useTranslation('common');
  const allColumns = useMemo(() => {
    const cols = [
      {
        title: tc('name'),
        dataIndex: 'name',
        key: 'name',
        fixed: 'left',
        width: 200,
        className: 'border-right',
      },
      {
        title: t('tag'),
        dataIndex: 'tag',
        key: 'tag',
        width: 170,
        render: (value) => {
          return <span className={'status ' + value.toLowerCase()}>{tc(`hubTags.${value}`)}</span>;
        },
      },
      {
        title: t('startAddress'),
        dataIndex: 'startAddress',
        key: 'startAddress',
        width: 700,
      },
      {
        title: t('endAddress'),
        dataIndex: 'endAddress',
        key: 'endAddress',
        width: 700,
      },
      {
        title: t('fleets'),
        key: 'countFleets',
        render: (record) => {
          return record?._count?.fleets || 0;
        },
      },
      {
        title: tc('updatedAt'),
        dataIndex: 'updatedAt',
        key: 'updatedAt',
        width: 250,
        render: (value) => {
          return value ? moment(value).format(DAYTIME_FORMAT) : '';
        },
      },
    ];

    if (withAction) {
      cols.push({
        key: 'action',
        width: 120,
        fixed: 'right',
        render(record) {
          return withAction(record);
        },
        className: 'border-left',
      });
    }

    return cols;
  }, [withAction]);

  const columnConfig = useColumnConfig('hubs-columns', allColumns, FIXED_KEYS);

  // Expose openDrawer to parent via ref
  if (configRef) {
    configRef.current = { openDrawer: columnConfig.openDrawer, pageSize: columnConfig.pageSize };
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <div className="table-job-orders table-common">
      <Table
        columns={columnConfig.visibleColumns}
        rowSelection={rowSelection}
        dataSource={dataSource}
        scroll={{ x: 2300 }}
        // bordered
        {...props}
      />
      <ColumnConfigDrawer
        open={columnConfig.drawerOpen}
        onClose={columnConfig.closeDrawer}
        columns={columnConfig.orderedAllColumns}
        hidden={columnConfig.hidden}
        fixedKeys={FIXED_KEYS}
        onToggle={columnConfig.toggleColumn}
        onMove={columnConfig.moveColumn}
        onReset={columnConfig.resetConfig}
        pageSize={columnConfig.pageSize}
        onPageSizeChange={columnConfig.setPageSize}
      />
    </div>
  );
}
